import { render, staticRenderFns } from "./AddApplicableArea.vue?vue&type=template&id=617c3b50&scoped=true&"
import script from "./AddApplicableArea.vue?vue&type=script&lang=js&"
export * from "./AddApplicableArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617c3b50",
  null
  
)

export default component.exports